<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid overflow-auto pt-5 mt-5" style="max-height: 860px;">

        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Rules Registration</h1>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-xl-12 col-md-12 mb-2">
                <div class="card border-left-primary shadow h-100 py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-xs font-weight-bold text-primary  mb-1">
                                    <form [formGroup]="rulesRegisterForm" (ngSubmit)="onRegister()">
                                        <div class="row">
                                              <!--Rule Name-->
                                            <div class="col-xl-3 col-md-3" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Rule Name</mat-label>
                                                        <input matInput formControlName="name" minlength="3" title="Name at least has 3 characters !">
                                                        <mat-error *ngIf="rulesRegisterForm.controls.name.errors?.required">This field is required !</mat-error>
                                                        <mat-error *ngIf="rulesRegisterForm.controls.name?.value">Name at least has 3 characters !</mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                               <!-- Rule Description-->
                                            <div class="col-xl-3 col-md-3" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Description</mat-label>
                                                        <input matInput formControlName="desc" minlength="3" title="Name at least has 3 characters !">
                                                        <mat-error *ngIf="rulesRegisterForm.controls.desc.errors?.required">This field is required !</mat-error>
                                                        <mat-error *ngIf="rulesRegisterForm.controls.desc?.value">Name at least has 3 characters !</mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                                  <!--priority-->
                                            <div class="col-xl-3 col-md-3" >
                                            <div class="form-group">
                                              <mat-form-field appearance="outline">
                                                <mat-label>Priority</mat-label>
                                                <input matInput formControlName="salience" type="number">
                                               </mat-form-field>
                                            </div>
                                          </div>
                                                  <!--Network Type-->
                                            <div class="col-xl-3 col-md-3" >
                                            <div class="form-group">
                                              <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Network Type:</mat-label>
                                                <mat-select formControlName="networkType" class="text-primary">
                                                  <mat-option class="text-primary" *ngFor="let items of nType" [value]="items.value">{{items.viewValue}}</mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                          </div>
                                                <!--Plan Type-->
                                            <div class="col-xl-3 col-md-3" >
                                            <div class="form-group">
                                              <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Plan Type:</mat-label>
                                                <mat-select formControlName="planType" class="text-primary">
                                                  <mat-option class="text-primary" *ngFor="let items of pType" [value]="items.value">{{items.viewValue}}</mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                          </div>
                                                <!--Form Type-->
                                            <div class="col-xl-3 col-md-3" >
                                              <div class="form-group">
                                                <mat-form-field appearance="outline" class="w-100">
                                                  <mat-label>Form Type:</mat-label>
                                                  <mat-select formControlName="formType" class="text-primary">
                                                    <mat-option class="text-primary" *ngFor="let items of fType" [value]="items.value">{{items.viewValue}}</mat-option>
                                                  </mat-select>
                                                </mat-form-field>
                                              </div>
                                            </div>
                                                <!--Question Category-->
                                            <div class="col-xl-3 col-md-3" >
                                            <div class="form-group">
                                              <mat-form-field appearance="outline" class="custom-mat-form-field">
                                                <mat-label>Select Category</mat-label>
                                                <mat-select [(ngModel)]="selectedCategory" (selectionChange)="changeCategory($event)" formControlName="category">
                                                  <mat-option *ngFor="let option of categoryArray" [value]="option.category">
                                                    {{ option.category }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                          </div>
                                              <!--Questions-->
                                            <div class="col-xl-3 col-md-3" >
                                            <div class="form-group">
                                              <mat-form-field appearance="outline" class="custom-mat-form-field">
                                                <mat-label>Select Question</mat-label>
                                                <mat-select [(ngModel)]="selectedQuestion" formControlName="question">
                                                  <mat-option *ngFor="let q of questionsList" [value]="q.question">
                                                    {{ q.question }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                            </div>
                                             <!-- Select coloumb-->
                                            <div class="col-xl-6 col-md-6" >
                                            <div class="form-group">
                                              <mat-form-field appearance="outline" class="w-100">
                                                <mat-label>Select Coloumb</mat-label>
                                                <mat-select formControlName="fieldName" class="text-primary">
                                                  <mat-option class="text-primary" *ngFor="let items of cType" [value]="items.value">{{items.viewValue}}</mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>
                                          </div>

                                            <div class="col-xl-6 col-md-6" >
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline">
                                                        <mat-label>Coloumb Value</mat-label>
                                                        <input matInput formControlName="response" minlength="3" title="Name at least has 3 characters !">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div *ngIf="ruleId" class="col-xl-1 col-md-6 mt-3 pt-2" >
                                                <div [ngClass]="status ? 'active' : 'inactive'"><span class="text-primary">Status :</span> {{status ? 'Active' : 'Inactive'}}
                                                    <label class="switch">
                                                        <input type="checkbox" class="success" [checked]="this.status" (click)="changeStatus(this.status)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <button type="button" routerLink="/rules"
                                                class="btn btn-secondary float-end  waves-effect waves-light">Cancel</button>
                                        <button *ngIf="!ruleId" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit"
                                                [disabled]="!rulesRegisterForm.valid">Register
                                        </button>
                                        <button *ngIf="ruleId" class="btn btn-outline-light btn-lg px-5 float-right" mat-raised-button color="primary" type="submit"
                                                [disabled]="!rulesRegisterForm.valid">Update
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
